import React, { PureComponent } from 'react'
import classNames from 'classnames'
import _ from 'lodash'
import { Icon, Menu } from 'antd'
import { Link } from 'react-router-dom'
import { urlToList } from '../_utils/pathTools'
import { getMenuMatches } from './SiderMenuUtils'
import { isUrl } from '../_utils/utils'
import rightAuth from '../_utils/userRights'
import styles from './index.less'

const { SubMenu } = Menu

const getIcon = icon => {
    if (typeof icon === 'string' && isUrl(icon)) {
        return <img src={icon} alt="icon" className={styles.icon} />
    }
    if (typeof icon === 'string') {
        return <Icon type={icon} />
    }
    return icon
}


export default class BaseMenu extends PureComponent {
    /**
     * @memberof SiderMenu
     */
    /* getNavMenuItems = (menusData, parent) => {

      if (!menusData) {
        return []
      }
      return menusData
        .filter(item => item.name && !item.hideInMenu)
        .map(item => {
          if (!item.dontShowOnMenu) {
            if (item.children && item.children.length) {
              rightAuth.checkSideMenuRights(item, (resp) => {
                if (resp) {
                  console.log(resp, item.name)
                  return this.getSubMenuOrItem(item, parent)
                }
              })
            } else {
              if (rightAuth.checkRights(item.rights)) {
                return this.getSubMenuOrItem(item, parent)
              }
            }

          }
        })
        .filter(item => item)
    } */

    getNavMenuItems = (menusData, parent) => {

        if (!menusData) {
            return []
        }
        return menusData
            .filter(item => item.name && !item.hideInMenu)
            .map((item, key) => {
                let dontShow = true

                if (item.children && item.children.length) {
                    dontShow = false
                    _.each(item.children, (child) => {
                        if (!child.dontShowOnMenu) {
                            let xx = rightAuth.checkRights(child.rights)
                            if (xx) {
                                dontShow = true
                            }
                        }

                    })
                }
                if (item.subRights != undefined && item.subRights && item.subRights.length > 0) {
                    if (!rightAuth.checkMultipleRights(item.subRights)) {
                        dontShow = false;
                    }
                }
                if (dontShow) {
                    if (!item.dontShowOnMenu) {
                        if (item.viewByBranch) {
                            if (rightAuth.checkRights(item.rights) && !rightAuth.checkRights(item.viewByBranch)) {
                                return this.getSubMenuOrItem(item, parent, key)
                            }
                        } else {
                            if (rightAuth.checkRights(item.rights)) {
                                return this.getSubMenuOrItem(item, parent, key)
                            }
                        }
                    }
                }
            })
            .filter(item => item)
    }


    // Get the currently selected menu
    getSelectedMenuKeys = pathname => {
        const { flatMenuKeys } = this.props
        return urlToList(pathname).map(itemPath =>
            getMenuMatches(flatMenuKeys, itemPath).pop()
        )
    }

    /**
     * get SubMenu or Item
     */
    getSubMenuOrItem = (item, parent, key) => {
        // doc: add hideChildrenInMenu
        if (
            item.children &&
            !item.hideChildrenInMenu &&
            item.children.some(child => child.name)
        ) {
            const { name } = item
            return (
                <SubMenu
                    title={
                        item.icon ? (
                            <span>
                                {getIcon(item.icon)}
                                <span>{name}</span>
                            </span>
                        ) : (
                            name
                        )
                    }
                    key={item.path + '-' + key}>
                    {this.getNavMenuItems(item.children)}
                </SubMenu>
            )
        }
        return <Menu.Item key={item.path}>{this.getMenuItemPath(item)}</Menu.Item>
    }

    /**
     * Judge whether it is http link.return a or Link
     * @memberof SiderMenu
     */
    getMenuItemPath = item => {
        const { name } = item
        const itemPath = this.conversionPath(item.path)
        const icon = getIcon(item.icon)
        const { target } = item
        // Is it a http link
        if (/^https?:\/\//.test(itemPath)) {
            return (
                <a href={itemPath} target={target}>
                    {icon}
                    <span>{name}</span>
                </a>
            )
        }
        const { location, isMobile, onCollapse } = this.props
        return (
            <Link
                className={'sidebaar-menu-item'}
                to={itemPath}
                target={target}
                replace={itemPath === location.pathname}
                onClick={
                    isMobile
                        ? () => {
                            onCollapse(true)
                        }
                        : undefined
                }>
                {icon}
                <span>{name}</span>
            </Link>
        )
    }

    conversionPath = path => {
        if (path && path.indexOf('http') === 0) {
            return path
        }
        return `/${path || ''}`.replace(/\/+/g, '/')
    }

    render() {
        const {
            openKeys,
            navTheme,
            mode,
            location: { pathname },
            className,
            collapsed
        } = this.props
        // if pathname can't match, use the nearest parent's key
        let selectedKeys = this.getSelectedMenuKeys(pathname)
        if (!selectedKeys.length && openKeys) {
            selectedKeys = [openKeys[openKeys.length - 1]]
        }
        let props = {}
        if (openKeys && !collapsed) {
            props = {
                openKeys: openKeys.length === 0 ? [...selectedKeys] : openKeys
            }
        }
        const { handleOpenChange, style, menuData } = this.props
        const cls = classNames(className, {
            'top-nav-menu': mode === 'horizontal'
        })

        return (
            <Menu
                key="Menu"
                mode={mode}
                theme={navTheme}
                onOpenChange={handleOpenChange}
                selectedKeys={selectedKeys}
                className={cls}
                {...props}>
                {this.getNavMenuItems(menuData)}
            </Menu>
        )
    }
}
